import { dispatch, req } from "hf-rt";

const initialState = {
  payload: {},
  recentlyViewedLoadComplete: false
};

export default {
  name: "browsingHistory",
  actions: {
    updateBrowsingHistory: payload =>
      dispatch({ type: "UPDATE_BROWSING_HISTORY", payload }),

    fetchBrowsingHistory: async function() {
      await dispatch({ type: "FETCH_BROWSING_HISTORY" });
      const data = await req.get({ api: "browsingHistory" });
      await this.updateBrowsingHistory(data);
    }
  },
  reducers: function(state = initialState, action) {
    switch (action.type) {
      case "UPDATE_BROWSING_HISTORY":
        return {
          ...state,
          payload: action.payload,
          recentlyViewedLoadComplete: true
        };

      default:
        return state;
    }
  }
};
